<div class="col-lg-12 col-md-12 col-sm-12 card" [ngClass]="{'dark-mode': darkMode}">
  <div class="card-header border-header">
    <div class="row d-flex justify-content-between align-items-center p-2">
      <h3 class="" translate>settings.logos</h3>
      <!-- search -->
      <div *ngIf="role === 'root'" class="d-flex search-container">
        <div class="search-text d-flex">
          <input type="text" class="search" (input)="applyFilterAddedLogos()" [(ngModel)]="searchParamAll"
            placeholder="Search by file name">
          <div class="d-flex flex-row align-items-center">
            <span class="exit" (click)="clearSearch()"></span>
            <span class="line"></span>
          </div>
        </div>
        <span class="search-icon"><i class="fa fa-search"></i></span>
      </div>
      <!-- ./search -->
      <div *ngIf="role === 'root' || role === 'customer'">
        <button type="button" class="custom-button add-button" style="float: right;"
          (click)="openAddLogoModal(addLogoModal)">Create
          Logo <i class="fa fa-plus" style="margin-left: 7px;"></i></button>
      </div>
    </div>
    <div *ngIf="role !== 'root'" class="form-group">
      <!-- search -->
      <div #searchContainer [ngClass]="{'active' : showMyContainer}" class="div select-bg search-container"
        style="display: block;">
        <input type="text" readonly class="search"
          style="height: 44px; display: block; width: 100%; padding-left: 12px;" (click)="openDropdown()"
          name="selectedLogo" [(ngModel)]="selectedLogo">
        <div class="prikaz" *ngIf="showMyContainer">
          <div class="backdrop" (click)="openDropdown()"></div>
          <div style="z-index: 100; overflow-y: auto;">
            <div class="divider"></div>
            <input type="text" class="search-marke" (input)="applyFilter()"
              [attr.placeholder]="'user.search' | translate" name="searchParam" name="searchParam"
              [(ngModel)]="searchParam">
            <ul style="margin-bottom: 12px;">

              <li *ngFor="let logo of logosSearch" (click)="assignLogo(logo.id)">
                {{ logo.filename }}
                <ng-container>
                  <div class="position-relative">
                    <div class="bg-all-files" style="cursor: pointer;"
                      [style.background-image]="logo?.thumbnailPath ? 'url(' + logo?.thumbnailPath + ')' : 'url(assets/img/no-image.png)'">
                    </div>
                  </div>
                </ng-container>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div *ngIf="logosSearchAll && !logosSearchAll.length" style="min-height: 60px;">
        <p class="no-data-message" translate>settings.noLogosAssigned</p>
      </div>
      <div class="col-md-3 col-sm-6"
        *ngFor="let logo of logosSearchAll| slice: (page-1) * perPage : (page-1) * perPage + perPage;; let index = index">
        <div class="root-application-bg-container">
          <div class="root-application-image-delete" (click)="openLogoModal(logoModal, logo)"></div>
          <div *ngIf="role === 'root'" class="root-application-image-delete settings-icon" style="cursor: pointer; left: 0;"
            (click)="editLogo(addLogoModal, logo)"></div>
          <div class="root-application-bg" [style.background-image]="'url(' + logo.path + ')'"></div>
          <div class="root-application-filename widget-user-username"> {{logo.filename}}</div>
        </div>
      </div>
    </div>
  </div>
  <ngb-pagination *ngIf="logosSearchAll && logosSearchAll.length > 16" [collectionSize]="logosSearchAll.length"
    [(pageSize)]="perPage" [(page)]="page" [maxSize]="5" [rotate]="true"
    (pageChange)="jumpToPage($event)"></ngb-pagination>
</div>

<!-- Modal add logo-->
<!-- <ng-template #addLogoModal let-c="close" let-d="dismiss">
  <div class="modal_container black-text">
    <div class="uploading" *ngIf="uploading">
      <strong>Uploading, please wait...</strong>
    </div>
    <div class="modal-header">
      <h4 class="modal-title">Add Logo</h4>
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form #formAddLogo="ngForm">
        <div class="form-group right col-lg-12 col-md-12 ">
          <input type="file" name="image" ngModel (change)="getFiles($event)" placeholder="Choose Image" />
        </div>
        <button type="button" class="custom-button save-button" (click)="uploadLogo()">Save</button>
      </form>
    </div>
  </div>
</ng-template> -->

<ng-template #addLogoModal let-c="close" let-d="dismiss">
  <div class="modal_container black-text">
    <div class="uploading" *ngIf="isUploading">
      <strong>Please wait...</strong>
    </div>
    <div class="modal-header">
      <h4 class="modal-title">{{ logo ? 'Edit Logo' : 'Add Logo' }}</h4>
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form #formAddLogo="ngForm">
        <div class="form-group">
          <label for="logoName">Logo Name</label>
          <input
            type="text"
            id="logoName"
            name="name"
            ngModel
            [(ngModel)]="logoName"
            placeholder="Enter logo name"
            class="form-control"
          />
        </div>
        <div class="form-group right col-lg-12 col-md-12">
          <div class="d-flex justify-content-between">
            <label for="logoFile">Logo File</label>
            <div>
              <img *ngIf="logo && !previewFile" style="width: 90px; height: auto; cursor: pointer;" [src]="logo.thumbnailPath" alt="" (click)="fileSelectorOpen()">
              <img *ngIf="previewFile" style="width: 90px; height: auto; cursor: pointer;" [src]="previewFile" alt="" (click)="fileSelectorOpen()">
              <div class="upload-button" *ngIf="!logo && !previewFile" (click)="fileSelectorOpen()">Upload file</div>
            </div>
            <!-- <button type="button" class="btn btn-secondary" (click)="changeFile = !changeFile">
              {{ changeFile ? 'Keep Current File' : 'Change File' }}
            </button> -->
            
          </div>
          <input
            style="display: none;"
            type="file"
            name="image"
            id="image"
            ngModel
            (change)="getFiles($event)"
            placeholder="Choose Image"
          />
        </div>
        <button type="button" class="custom-button save-button" (click)="uploadLogo()">
          Save
        </button>
      </form>
    </div>
  </div>
</ng-template>



<!-- Modal delete logo-->
<ng-template #logoModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <p>Are you sure you want to delete the logo?</p><br>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="image-delete-thumb mt-1 mb-3" [style.background-image]="'url(' + logoToDelete?.path + ')'"></div>
    <button type="button" class="btn btn-outline-dark btn-yes" (click)="deleteLogo(logoToDelete)"
      translate>global.yes</button>
    <button type="button" class="btn btn-outline-dark btn-no" (click)="c('No click')" translate>global.no</button>
  </div>
</ng-template>